import { Card, CardContent, Typography, Box, SVGIcon, Link, KeyboardArrowRightIcon } from 'src/components';
import { useNavigate } from 'react-router-dom';

export default function CategoryCard({ category, groupColor }) {
  const navigate = useNavigate();
  const isDisabled = category.disabled;

  return (
    <Link 
      onClick={() => navigate(`/handbook/${category.slug}`)} 
      style={{ textDecoration: 'none', pointerEvents: isDisabled ? 'none' : 'auto', }}>

      <Card
        sx={{
          height: '100%',
          cursor: isDisabled ? 'default' : 'pointer',
          transition: 'all 0.3s ease',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: isDisabled ? 'grey.100' : 'background.paper',
          opacity: isDisabled ? 0.6 : 1,
          '&:hover': isDisabled
            ? {}
            : {
            transform: 'translateY(-6px)',
            boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
            borderColor: groupColor,
            '& .icon': {
              transform: 'scale(1.1) rotate(4deg)'
            },
            '& .chevron': {
              transform: 'translateX(4px)',
              color: groupColor
            }
          }
        }}
      >
        <CardContent
          sx={{
            p: 1,
            pt: 4,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start'
          }}
        >
          {/* Icon */}
          <Box className="icon" sx={{ mr: 2 }}>
            <SVGIcon icon={category.icon} size={60} color={groupColor}/>
          </Box>

          {/* Text */}
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6" fontWeight="600" color="text.primary">
                {category.title}
              </Typography>
              <KeyboardArrowRightIcon className="chevron" sx={{ transition: 'transform 0.2s', color: 'text.secondary' }} />
            </Box>

            <Typography variant="body2" color="text.secondary">
              {category.description}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Link>
  );
}
